import { FC } from 'react';
import { useTemplateExpressionValidation } from '../../hooks/useTemplateExpressionValidation';
import { MAlert } from './MAlert';
import MText from './MText';

interface TemplateExpressionWarningProps {
  /** Rich text (HTML) content that may contain {{...}} template expressions */
  value: string | null | undefined;
}

/**
 * Non-blocking syntax warning for template expressions inside rich text
 * content (contract terms, invoice terms, conditional terms). Renders
 * nothing when every expression parses, and never prevents saving —
 * existing stored content may already contain broken expressions.
 */
export const TemplateExpressionWarning: FC<TemplateExpressionWarningProps> = ({
  value,
}) => {
  const errors = useTemplateExpressionValidation(value);

  if (errors.length === 0) {
    return null;
  }

  return (
    <MAlert type="warning" mt="2">
      <MText fontSize="sm" fontWeight={600}>
        {errors.length === 1
          ? 'This merge field has a syntax error and will appear blank in generated documents:'
          : 'These merge fields have syntax errors and will appear blank in generated documents:'}
      </MText>
      {errors.map(({ expression, error }, index) => (
        <MText
          key={`${expression}-${index}`}
          as="code"
          display="block"
          fontSize="xs"
          fontFamily="mono"
          title={error}
          mt="1"
        >
          {expression}
        </MText>
      ))}
    </MAlert>
  );
};
